import { render } from "./icon.vue?vue&type=template&id=44fd5a02&scoped=true&ts=true"
import script from "./icon.vue?vue&type=script&lang=ts"
export * from "./icon.vue?vue&type=script&lang=ts"

import "./icon.vue?vue&type=style&index=0&id=44fd5a02&lang=scss&scoped=true"

import exportComponent from "/tmp/build_c94111dd/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-44fd5a02"]])

export default __exports__